export default "__VITE_ASSET__DPEkRZLg__"